import { render, staticRenderFns } from "./resetPassword1.vue?vue&type=template&id=066e6ca4&scoped=true&"
import script from "./resetPassword1.vue?vue&type=script&lang=js&"
export * from "./resetPassword1.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword1.vue?vue&type=style&index=0&id=066e6ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e6ca4",
  null
  
)

export default component.exports